export default function TeamItem({team}) {
    return (
        <li className={`li_team_${team.teamId}`} draggable>
             <span className="handle">
              <i className="fas fa-ellipsis-v"></i>
              <i className="fas fa-ellipsis-v"></i>
            </span>
            <div className="icheck-success d-inline ml-2">
                <input type="checkbox" value={team.teamId} name={`team_${team.teamId}`}
                       id={`todoCheck_${team.teamId}`} />
                <label htmlFor={`todoCheck_${team.teamId}`}></label>
            </div>
            <span className="text">{team.teamName}</span>
        </li>
    );
}